export const navToggle = document.querySelector('[data-nav-toggle]')
export const navPanel = document.querySelector('[data-nav-panel]')

export const closeNav = () => {
  navPanel?.classList.remove('is-open')
  navToggle?.classList.remove('is-open')
  navToggle?.setAttribute('aria-expanded', 'false')
}

export function initNav() {
  navToggle?.addEventListener('click', () => {
    const isOpen = navPanel.classList.toggle('is-open')
    navToggle.classList.toggle('is-open', isOpen)
    navToggle.setAttribute('aria-expanded', String(isOpen))
  })
}
